// Keep Shopify's own financing estimates and disclosures. Enlarge the sample-plan
// control and route its checkout action through the cart's terms gate.
const enhanced=new WeakSet();
const gated=new WeakSet();
const observedPortals=new WeakSet();
let source=null;
const placedPortals=new WeakSet();
function placePortal(portal){
  if(!portal.shadowRoot?.querySelector('[role="dialog"][data-visible="true"]'))return;
  const drawer=source?.closest('cart-drawer-component');
  const dialog=drawer?.querySelector('dialog');
  if(!dialog?.open || portal.parentElement===dialog)return;
  dialog.append(portal);
  if(!placedPortals.has(portal)){
    placedPortals.add(portal);
    drawer.addEventListener('dialog:close',()=>{
      if(portal.parentElement===dialog)document.body.append(portal);
      placedPortals.delete(portal);
    },{once:true});
  }
}

function enhance(){
  for(const terms of document.querySelectorAll('shopify-payment-terms')){
    if(!terms.closest('cart-items-component'))continue;
    // Shopify's Liquid filter initializes product forms with the first variant,
    // even when the cart row's hidden input names the upgraded cart variant.
    const row=terms.closest('.cart-items__table-row[data-key]');
    const selected=row&&terms.closest('form')?.querySelector('input[name="id"]')?.value;
    if(selected && terms.getAttribute('variant-id')!==selected)terms.setAttribute('variant-id',selected);
    terms.style.fontFamily='inherit';
    terms.style.fontSize='12px';
    terms.style.lineHeight='1.35';
    const button=terms.shadowRoot?.querySelector('#shopify-installments-cta');
    if(!button||enhanced.has(button))continue;
    enhanced.add(button);
    button.style.minWidth='44px';
    button.style.minHeight='44px';
    button.style.display='inline-flex';
    button.style.alignItems='center';
    button.style.justifyContent='center';
    button.style.verticalAlign='middle';
    button.style.marginInline='-12px';
    button.setAttribute('aria-label','View Shop Pay sample plans');
    button.addEventListener('click',()=>{
      source=terms;
      for(const portal of document.querySelectorAll('[data-nametag="shop-portal-provider"]'))placePortal(portal);
    },true);
  }
  for(const portal of document.querySelectorAll('[data-nametag="shop-portal-provider"]')){
    placePortal(portal);
    if(portal.shadowRoot&&!observedPortals.has(portal)){
      observedPortals.add(portal);
      new MutationObserver(()=>queueMicrotask(enhance)).observe(portal.shadowRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['data-visible']});
    }
    const button=portal.shadowRoot?.querySelector('[data-native-terms-checkout]') || [...portal.shadowRoot?.querySelectorAll('button')||[]].find(item=>item.textContent.trim()==='Continue to checkout');
    if(!button)continue;
    button.dataset.nativeTermsCheckout='1';
    const context=source?.closest('cart-items-component') || document.querySelector('.cart-page cart-items-component');
    const checkbox=context?.querySelector('[data-native-cart-terms-checkbox]');
    const label=checkbox?.checked?'Continue to checkout':'Review terms in cart';
    if(button.textContent.trim()!==label)button.textContent=label;
    if(gated.has(button))continue;
    gated.add(button);
    button.addEventListener('click',event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      const context=source?.closest('cart-items-component') || document.querySelector('.cart-page cart-items-component');
      const control=context?.querySelector('[data-native-cart-terms]');
      const checkbox=control?.querySelector('[data-native-cart-terms-checkbox]');
      if(!checkbox?.checked){
        portal.shadowRoot.querySelector('button[aria-label="Close"]')?.click();
        const drawer=source?.closest('cart-drawer-component');
        if(drawer && !drawer.querySelector('dialog')?.open)drawer.open();
        const error=control?.querySelector('[data-native-cart-terms-error]');
        requestAnimationFrame(()=>{if(error)error.hidden=false;control?.scrollIntoView({behavior:'smooth',block:'center'});checkbox?.focus({preventScroll:true});});
        return;
      }
      portal.shadowRoot.querySelector('button[aria-label="Close"]')?.click();
      context.querySelector('button[name="checkout"]')?.click();
    },true);
  }
}
customElements.whenDefined('shopify-payment-terms').then(enhance);
new MutationObserver(()=>queueMicrotask(enhance)).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('cart:update',()=>queueMicrotask(enhance));
document.addEventListener('change',event=>{if(event.target.matches?.('[data-native-cart-terms-checkbox]'))queueMicrotask(enhance);},true);
